import React, { useContext, useState } from "react";
import AdvisorNavbar from "../layout/AdvisorNavbar";
import LocContext from "../context/locContext";
import {  FiDownload, FiBell, FiTrendingUp, FiCalendar } from "react-icons/fi";
import { NavLink } from "react-router-dom";

export default function PlanSales() {
  const { userData } = useContext(LocContext);
  const [filterType, setFilterType] = useState("all");

  const formatINR = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const [salesData] = useState({
    totalSales: 125000,
    activePlans: 8,
    renewalsDue: 3,
    monthlyRevenue: 15000,
  });

  const [planSales] = useState([
    {
      id: 1,
      clientName: "Rajesh Kumar",
      planName: "Premium Research Plan",
      purchaseDate: "2024-01-15",
      expiryDate: "2025-01-15",
      amount: 15000,
      status: "Active",
      renewalDue: false,
    },
    {
      id: 2,
      clientName: "Priya Sharma",
      planName: "Basic Research Plan",
      purchaseDate: "2023-12-20",
      expiryDate: "2024-12-20",
      amount: 10000,
      status: "Active",
      renewalDue: true,
    },
    {
      id: 3,
      clientName: "Amit Patel",
      planName: "Premium Research Plan",
      purchaseDate: "2024-01-10",
      expiryDate: "2025-01-10",
      amount: 15000,
      status: "Active",
      renewalDue: false,
    },
    {
      id: 4,
      clientName: "Sneha Reddy",
      planName: "Basic Research Plan",
      purchaseDate: "2023-11-15",
      expiryDate: "2024-11-15",
      amount: 10000,
      status: "Expired",
      renewalDue: true,
    },
  ]);

  const filteredSales = planSales.filter(sale => {
    if (filterType === "all") return true;
    if (filterType === "renewals") return sale.renewalDue;
    return sale.status.toLowerCase() === filterType.toLowerCase();
  });

  const handleExport = () => {
    alert("Export functionality will be implemented");
  };

  const handleSetReminder = (saleId) => {
    alert(`Reminder set for plan sale ${saleId}`);
  };

  return (
    <>
    <AdvisorNavbar />
    <div className="page-content" style={{ background: "#f1f5f9" }}>

          {/* Header */}
          <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px" }}>
            {/* <div style={{
              background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
              padding: "20px",
              borderRadius: "12px",
              borderBottom: "3px solid #39b2b4",
            }}> */}
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <div>
                  <h2 className="mb-1" >
                    Research Plan Sales
                  </h2>
                  <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/agent/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">Research Plan Sales</li>
                </ol>
              </nav>  
                </div>
                <button
                  className="btn btn-primary"
                  onClick={handleExport}
                  style={{
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "10px 20px",
                    fontWeight: "500",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <FiDownload style={{ fontSize: "18px" }} />
                  Export
                </button>
              </div>
            {/* </div> */}
          </div>

          {/* Summary Cards */}
          <div className="row g-3 mb-4">
            <div className="col-12 col-md-6 col-lg-3">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                  borderLeft: "4px solid #1bafb4",
                }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Total Sales</p>
                      <h3 className="mb-0" style={{ color: "#1bafb4",  }}>
                        {formatINR(salesData.totalSales)}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)",
                  borderLeft: "4px solid #10b981",
                }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Active Plans</p>
                      <h3 className="mb-0" style={{ color: "#10b981",  }}>
                        {salesData.activePlans}
                      </h3>
                    </div>
                    <FiTrendingUp style={{ fontSize: "28px", color: "#10b981" }} />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #fff7ed 100%)",
                  borderLeft: "4px solid #f59e0b",
                }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Renewals Due</p>
                      <h3 className="mb-0" style={{ color: "#f59e0b",  }}>
                        {salesData.renewalsDue}
                      </h3>
                    </div>
                    <FiCalendar style={{ fontSize: "28px", color: "#f59e0b" }} />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                  borderLeft: "4px solid #1bafb4",
                }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="mb-1" style={{ color: "#64748b", fontSize: "14px", fontWeight: "500" }}>Monthly Revenue</p>
                      <h3 className="mb-0" style={{ color: "#1bafb4",  }}>
                        {formatINR(salesData.monthlyRevenue)}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Filter */}
          <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px" }}>
            <div className="row g-3">
              <div className="col-12 col-md-4">
                <select
                  className="form-select"
                  value={filterType}
                  onChange={(e) => setFilterType(e.target.value)}
                  style={{
                    borderRadius: "8px",
                    border: "2px solid #e2e8f0",
                    fontSize: "14px",
                  }}
                >
                  <option value="all">All Plans</option>
                  <option value="active">Active</option>
                  <option value="expired">Expired</option>
                  <option value="renewals">Renewals Due</option>
                </select>
              </div>
            </div>
          </div>

          {/* Sales List */}
          <div className="card shadow-sm" style={{ borderRadius: "12px", border: "none" }}>
            <div className="card-body p-4">
              <div style={{
                background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                padding: "16px",
                borderRadius: "12px",
                borderBottom: "3px solid #39b2b4",
                marginBottom: "24px",
              }}>
                <h4 className="mb-0" >
                  Plan Sales List
                </h4>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr style={{ background: "#f8fafc" }}>
                      <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Client Name</th>
                      <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Plan Name</th>
                      <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Purchase Date</th>
                      <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Expiry Date</th>
                      <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Amount</th>
                      <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Status</th>
                      <th style={{ color: "#1bafb4", fontSize: "14px", fontWeight: "600", border: "none", padding: "12px" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredSales.map((sale) => (
                      <tr key={sale.id} style={{ borderBottom: "1px solid #e2e8f0" }}>
                        <td style={{ padding: "12px", color: "#1e293b", fontWeight: "500" }}>{sale.clientName}</td>
                        <td style={{ padding: "12px", color: "#1e293b" }}>{sale.planName}</td>
                        <td style={{ padding: "12px", color: "#64748b", fontSize: "14px" }}>
                          {new Date(sale.purchaseDate).toLocaleDateString()}
                        </td>
                        <td style={{ padding: "12px", color: "#64748b", fontSize: "14px" }}>
                          {new Date(sale.expiryDate).toLocaleDateString()}
                        </td>
                        <td style={{ padding: "12px", color: "#1bafb4", fontWeight: "600" }}>
                          {formatINR(sale.amount)}
                        </td>
                        <td style={{ padding: "12px" }}>
                          <span className="badge" style={{
                            background: sale.status === "Active" ? "#d1fae5" : "#fee2e2",
                            color: sale.status === "Active" ? "#10b981" : "#ef4444",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}>
                            {sale.status}
                          </span>
                          {sale.renewalDue && (
                            <span className="badge ms-2" style={{
                              background: "#fef3c7",
                              color: "#f59e0b",
                              padding: "6px 12px",
                              borderRadius: "6px",
                              fontSize: "12px",
                              fontWeight: "600",
                            }}>
                              Renewal Due
                            </span>
                          )}
                        </td>
                        <td style={{ padding: "12px" }}>
                          {sale.renewalDue && (
                            <button
                              className="btn btn-sm"
                              onClick={() => handleSetReminder(sale.id)}
                              style={{
                                background: "linear-gradient(135deg, #ccf1f7 0%, #b3eaf4 100%)",
                                color: "#1bafb4",
                                border: "none",
                                borderRadius: "6px",
                                padding: "6px 12px",
                                fontSize: "12px",
                                fontWeight: "500",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <FiBell style={{ fontSize: "14px" }} />
                              Reminder
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
     
    </div>
    </>
  );
}
